/* ============================================================
   開發模式的控制項（底列右側）
   ============================================================

   開發模式四件（使用者 2026-08-02 全選）：
     ① 變體／精英切換　② 群體壓力 0–420 + draw call 讀數
     ③ 剪影模式（全黑）　④ 忽略解鎖（看得到全部）

   **只多顯示，不改版面** —— 它是同一個畫面的另一組資料，不是另一個畫面。
   從 `ui/codex.ts` 拆出來純粹是行數（B3 之後那一支放不下）。 */

var $ = function (id) { return document.getElementById(id) as any; };

/** `st` 是圖鑑的開發模式狀態物件（`ui/codex.ts` 持有）。 */
export function devControlsHTML(T, st) {
  /* Boss 沒有變體、沒有精英、也沒有群體壓力（一次只有一隻）——
     那一格換成階段切換，那才是 Boss 唯一要驗的東西。 */
  if (T && T.boss) {
    var n = T.stages || 2;
    return '<label><input type="checkbox" id="cvSil"' + (st.sil ? ' checked' : '') + '>剪影</label>'
      + '<button id="cvStg" class="' + (st.stg ? 'on' : '') + '">階段 '
      + (Math.min(st.stg, n - 1) + 1) + '/' + n + '</button>'
      + '<button id="cvDie" class="' + (st.die ? 'on' : '') + '">死亡編排</button>';
  }
  /* 精英已經是掃描艙的「一般／精英」切換（玩家模式也有），底列不再重複一份。
     這裡留的是**只有開發模式該有的**：剪影、死亡動畫、變體、群體壓力。 */
  return '<label><input type="checkbox" id="cvSil"' + (st.sil ? ' checked' : '') + '>剪影</label>'
    + '<button id="cvDie" class="' + (st.die ? 'on' : '') + '">死亡動畫</button>'
    + '<button id="cvVar" class="' + (st.vi ? 'on' : '') + '">變體 ' + (st.vi + 1) + '/3</button>'
    + '<label>群體 <input type="range" id="cvSwarm" min="0" max="420" step="10" value="' + st.swarm + '"></label>';
}

/** `onModel` = 只要重建展品；`onAll` = 連控制項的文字都要重畫。 */
export function bindDevControls(T, st, onModel, onAll) {
  var sil = $('cvSil');
  if (sil) sil.onchange = function (e) { st.sil = e.target.checked; onModel(); };
  if (T && T.boss) {
    var stg = $('cvStg');
    if (stg) {
      stg.onclick = function () {
        st.stg = (st.stg + 1) % (T.stages || 2);
        onAll();
      };
    }
    var bd = $('cvDie');
    if (bd) bd.onclick = function () { st.die = !st.die; onAll(); };
    return;
  }
  /* 死亡動畫**只在開發模式**（使用者 2026-08-03 指定）。它會一直重播，
     所以是一個開關不是一顆「播一次」—— 塌陷只有 0.6 秒，播一次看不清楚。 */
  var di = $('cvDie');
  if (di) di.onclick = function () { st.die = !st.die; onAll(); };
  var vr = $('cvVar');
  if (vr) vr.onclick = function () { st.vi = (st.vi + 1) % 3; onAll(); };
  var sw = $('cvSwarm');
  if (sw) sw.oninput = function (e) { st.swarm = +e.target.value; };
}
